// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ef7C","field":"styles_field__2Mubr","fieldCol":"styles_fieldCol__1IPGG","diffCol":"styles_diffCol__3uUjC","diff":"styles_diff__3UcOX"};